import React, { useState } from "react";
import { BtnState } from "../interfaces/App";
import Icon, { IconType } from "./Icon";
interface IProps {
    value: string;
    label: string;
    className?: string;
    setState?: (value: string) => void;
    type?: string;
    placeholder?: string;
    disabled?: boolean;
    readOnly?: boolean;
    autoComplete?: string;
    eye?: boolean;
    tabIndex?: number;
}
function CustomInput(props: IProps) {
    const ref: React.RefObject<HTMLInputElement> = React.createRef();
    const [focus, setFocus] = useState(false);
    const [type, setType] = useState(props.type === "password" ? props.type : undefined);
    const eye = (t: string) => {
        return t && props.eye && !props.disabled ? (
            <div
                className="hiddenInput"
                onClick={() => setType(type === "password" ? "text" : "password")}
            >
                <Icon
                    icon={t === "text" ? IconType.eye : IconType.eyeOff}
                    state={BtnState.active}
                    className={"icon"}
                />
            </div>
        ) : (null);
    }
    return (
        <div 
            className={`customInput ${props.className} ? ${props.className} : ""`}
            onClick={() => ref.current.focus()}
        >
            <label
                className={props.value.length || focus ? "animatedLabel--animated" : "animatedLabel"}
            >
                {props.label}
            </label>
            <input
                ref={ref}
                type={type}
                value={props.value}
                onChange={(ev: any) => props.setState(ev.target.value)}
                placeholder={focus && !props.value.length ? props.placeholder : ""}
                onFocus={() => setFocus(true)}
                onBlur={() => setFocus(false)}
                disabled={props.disabled}
                readOnly={props.readOnly}
                autoComplete ={props.autoComplete ? props.autoComplete : "off"}
                tabIndex={props.tabIndex}
            />
            {eye(type)}
        </div>
    );
}
export default (CustomInput);
